import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-gray-600 body-font" }
const _hoisted_2 = { class: "container px-5 py-24 mx-auto" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"flex flex-wrap w-full mb-20\"><div class=\"lg:w-1/2 w-full mb-6 lg:mb-0\"><h1 class=\"sm:text-3xl text-2xl font-medium title-font mb-2 text-gray-300\">NFT Staking</h1><div class=\"h-1 w-40 bg-indigo-500 rounded\"></div></div><p class=\"lg:w-1/2 w-full leading-relaxed text-gray-200\" style=\"font-family:starforge,sans-serif;\"> You can stake your Alien Universe NFTs 🎉 in different farms.</p></div>", 1)
const _hoisted_4 = { class: "flex flex-wrap -m-4" }
const _hoisted_5 = { class: "xl:w-2/8 md:w-1/2 p-4" }
const _hoisted_6 = { class: "nes-container is-rounded is-dark" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h3", { class: "tracking-widest text-indigo-500 text-xs font-medium starforge title-font" }, "NFT/$ALIEN/$USDC", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h2", { class: "text-lg text-gray-100 font-medium title-font starforge mb-4" }, "$ALIEN $USDC Farm", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "leading-relaxed text-base sharetech" }, [
  /*#__PURE__*/_createTextVNode("Stake your NFT to farm "),
  /*#__PURE__*/_createElementVNode("strong", null, "$ALIEN"),
  /*#__PURE__*/_createTextVNode(" and "),
  /*#__PURE__*/_createElementVNode("strong", null, "$USDC")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "is-primary sharetech" }, "ACTIVE", -1)
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"xl:w-2/8 md:w-1/2 p-4\"><div class=\"nes-container is-rounded is-dark\"><h3 class=\"tracking-widest text-indigo-500 text-xs font-medium starforge title-font\">$ALIEN/NFT</h3><h2 class=\"text-lg text-gray-100 font-medium title-font starforge mb-4\">NFT Farm</h2><p class=\"leading-relaxed text-base sharetech\">Stake $ALIEN to farm <strong>NFT</strong> from the community wallet.</p><a href=\"#\" class=\"nes-badge\"><span class=\"is-warning sharetech\">COMING SOON!</span></a></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _hoisted_8,
            _hoisted_9,
            _createVNode(_component_router_link, {
              to: "/farmer/2cXNuoCL321XHZnz3qNJfwdmgugY1NGVjwuHBAaxA3Mt",
              class: "nes-badge"
            }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            })
          ])
        ]),
        _hoisted_11
      ])
    ])
  ]))
}